'use strict';
class SecureFileUploaderController {
  constructor(secureFileUploaderService, statusIndicatorService, $rootScope) {
    this.name = 'secureFileUploader';
    this.secureFileUploaderService = secureFileUploaderService;
    this.$rootScope = $rootScope;
    this.statusIndicatorService = statusIndicatorService;  
    this.uploadState = this.secureFileUploaderService.getUploadState();
    this.initStateAfterUploadStarted();
    this.listenForBatchStatusRetrieved();
    this.listenForImpersonate();
  }

  isInProgress() {
    return this.secureFileUploaderService.isInProgress();
  }

  isWaitingForUpload() {
    return this.secureFileUploaderService.isWaitingForUpload();
  }

  hasValidateError() {
    return this.secureFileUploaderService.hasValidateError();
  }

  hasProcessError() {
    return this.secureFileUploaderService.hasProcessError();
  }

  isProcessComplete() {
    return this.secureFileUploaderService.isProcessComplete();
  }

  listenForBatchStatusRetrieved() {
    const batchStatusRetrieved = this.statusIndicatorService.getBatchStatusEventName();
    this.$rootScope.$on(batchStatusRetrieved,(event, lastBatch) => {
      this.secureFileUploaderService.applyBatchChanges(lastBatch);
    });
  }

  listenForImpersonate() {
    this.$rootScope.$on('impersonate', this.onImpersonate.bind(this));
  }

  onImpersonate() {
    this.secureFileUploaderService.cancel();
  }

  initStateAfterUploadStarted() {
    if(this.isProcessComplete()) {
      this.secureFileUploaderService.cancel();
    }
    if(this.isInProgress()) {
      this.statusIndicatorService.retrieveStatus();
    }
  }

  hasS3UploadError() {
    return this.secureFileUploaderService.hasS3UploadError();
  }
}

SecureFileUploaderController.$inject = ['secureFileUploaderService', 'statusIndicatorService', '$rootScope'];

export default SecureFileUploaderController;



// WEBPACK FOOTER //
// ./app/components/secureFileUploader/secureFileUploader.controller.js